import Headroom from 'headroom.js';
import { breakpoints } from './breakpoints';

export default function navigation() {
  if ($('.headroom').length) {
    const headroom = new Headroom(document.querySelector('.headroom'), {
      offset: 50,
      tolerance: 5,
    });
    headroom.init();
  }

  /**
   * Mobile navigation
   */
  const $mobileToggler = $('.nav-toggler');
  const $mobileNav = $($mobileToggler.attr('data-target'));
  $mobileNav
    .find('.search-form, .menu-item, .nav-separator, .social, .wpml-ls')
    .each(function (index) {
      $(this).addClass(`menu-item-animated menu-item-animated--${index}`);
    });

  $mobileToggler.on('click', function (e) {
    e.preventDefault();

    $mobileToggler.toggleClass('is-active');
    $('body').toggleClass('navbar--opened');
    if (!$('body').hasClass('navbar--opened')) {
      $('body').addClass('navbar--closing');
      setTimeout(function () {
        $('body').removeClass('navbar--closing');
      }, 500);
    }
  });

  $(window).on('resize', function (e) {
    if ($(this).width() >= breakpoints.xl) {
      $mobileToggler.removeClass('is-active');
      $('body').removeClass('navbar--opened');
    }
  });

  /**
   * Close menu on item click
   */
  $mobileNav.find('a').on('click', function () {
    if (!$(this).attr('href').startsWith('#')) {
      $mobileToggler.removeClass('is-active');
      $('body').removeClass('navbar--opened');
    }
  });

  /**
   * Disabled links
   */
  $('.nav a[href="#"]')
    .addClass('disabled')
    .on('click', function (e) {
      e.preventDefault();
    });

  /**
   * Contact link on mobile
   */
  $('.nav-mobile .contact a')
    .addClass('no-scroll')
    .on('click', function (e) {
      e.preventDefault();
      const scrollTop = $('#footer-mobile-menu').offset().top;

      $('.nav-mobile').animate(
        {
          scrollTop,
        },
        1000
      );
    });
}
